/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Case_Sensitive_LabelInputs */

const en_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case Sensitive`)
};

const fr_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sensible a la casse`)
};

const de_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groß-/Kleinschreibung beachten`)
};

const it_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiuscole e minuscole`)
};

const ru_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С учетом регистра`)
};

const es_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distingue mayúsculas y minúsculas`)
};

const zh_cn2_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`区分大小写`)
};

const ja_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字と小文字を区別`)
};

const hi_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षर संवेदनशील`)
};

const pt_pt2_find_replace_case_sensitive_label = /** @type {(inputs: Find_Replace_Case_Sensitive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maiúsculas e minúsculas`)
};

/**
* | output |
* | --- |
* | "Case Sensitive" |
*
* @param {Find_Replace_Case_Sensitive_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_case_sensitive_label = /** @type {((inputs?: Find_Replace_Case_Sensitive_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Case_Sensitive_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_case_sensitive_label(inputs)
	if (locale === "de") return de_find_replace_case_sensitive_label(inputs)
	if (locale === "it") return it_find_replace_case_sensitive_label(inputs)
	if (locale === "ru") return ru_find_replace_case_sensitive_label(inputs)
	if (locale === "es") return es_find_replace_case_sensitive_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_case_sensitive_label(inputs)
	if (locale === "ja") return ja_find_replace_case_sensitive_label(inputs)
	if (locale === "hi") return hi_find_replace_case_sensitive_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_case_sensitive_label(inputs)
	return en_find_replace_case_sensitive_label(inputs)
});